export const ID_TOKEN_KEY = "idToken";
export const ACCESS_TOKEN_KEY = "accessToken";
export const REFRESH_TOKEN_KEY = "refreshToken";
export const PKCE_STORAGE_KEY = "pkceKey";
export const CLIENT_CONFIG_STORAGE_KEY = "clientConfig";
export const CLEAR_SESSION_STORAGE_KEY = "clearSession";
export const REDIRECT_PATH_STORAGE_KEY = "redirectPath";
